import React from 'react';

import { Accordion, Box, Text } from '@zillow/constellation-10';

import { formatDisclaimerContent } from './formatDisclaimerContent';

export type DisclaimerContentItem = {
  header?: string;
  description?: Array<{
    text: string;
    url?: string;
    stylings?: Array<string>;
  }>;
};

type ExpandableDisclaimerProps = {
  title: string;
  disclaimerContent: Array<DisclaimerContentItem> | DisclaimerContentItem | undefined;
  fontType?: string;
  onClick?: () => void;
};

const ExpandableDisclaimer = ({ title, disclaimerContent, fontType = 'legal', onClick }: ExpandableDisclaimerProps) => {
  // Handle both array format and single object format
  const disclaimers = Array.isArray(disclaimerContent)
    ? disclaimerContent
    : disclaimerContent
      ? [disclaimerContent]
      : [];

  return (
    <Accordion.Root defaultExpanded={[]} onClick={onClick} data-testid="disclaimer-accordion">
      <Accordion.Item value="disclaimer">
        <Accordion.Header data-test-id="disclaimer-expanded-header" data-testid="disclaimer-toggle">
          <Text textStyle="body-sm-bold">{title}</Text>
        </Accordion.Header>
        <Accordion.Panel data-test-id="disclaimer-expanded-content">
          {disclaimers.map((disclaimer, idx) => (
            <Box key={`disclaimer-${idx}`} css={{ marginBottom: '400' }}>
              <Text textStyle="body-xs" css={{ display: 'block', marginBottom: '200', textDecoration: 'underline' }}>
                {disclaimer.header}
              </Text>
              <Box data-testid={`disclaimer-expanded-content-${idx}`}>
                {formatDisclaimerContent({
                  styledTextList: disclaimer.description,
                  fontType,
                })}
              </Box>
            </Box>
          ))}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  );
};

export default ExpandableDisclaimer;
